import { useState, useCallback } from 'react';

export type SidebarVariant = 'sidebar' | 'floating' | 'inset';
export type SidebarCollapsible = 'offcanvas' | 'icon' | 'none';
export type SidebarSide = 'left' | 'right';

export interface LayoutConfig {
  sidebarVariant: SidebarVariant;
  sidebarCollapsible: SidebarCollapsible;
  sidebarSide: SidebarSide;
}

const DEFAULT_LAYOUT: LayoutConfig = {
  sidebarVariant: 'inset',
  sidebarCollapsible: 'icon',
  sidebarSide: 'left',
};

const STORAGE_KEY = 'converse-layout-config';

export function useLayoutConfig(): [LayoutConfig, (config: LayoutConfig) => void] {
  const [layoutConfig, setLayoutConfigState] = useState<LayoutConfig>(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved) return { ...DEFAULT_LAYOUT, ...JSON.parse(saved) };
    } catch { /* ignore */ }
    return DEFAULT_LAYOUT;
  });

  const setLayoutConfig = useCallback((config: LayoutConfig) => {
    setLayoutConfigState(config);
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(config)); } catch { /* ignore */ }
  }, []);

  return [layoutConfig, setLayoutConfig];
}
